// extracted by mini-css-extract-plugin
module.exports = {"ModalBody":"login_ModalBody__1Ouss"};